import "./MaterialUITooltip.scss";

import React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { withStyles, Theme } from '@material-ui/core/styles';
import clsx from "clsx";

// Prepare HOC update if we're going to remove the scss
const CustomTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    // backgroundColor: '#414A4F',
    // color: 'white',
    // fontSize: 14,
    // boxSadow: '0 0 15px rgba(0, 0, 0, 0.17)'
  },
}))(Tooltip);

interface MaterialUITooltipProps extends TooltipProps {}

const MaterialUITooltip: React.FC<MaterialUITooltipProps> = (props) => {
  return <CustomTooltip {...props} classes={{ ...props.classes, tooltip: clsx('mu-tooltip', props.classes?.tooltip)}} />;
};

export default MaterialUITooltip;
